import { createAction } from '@reduxjs/toolkit';

import { Document, FileType } from '../../types/common.types';
import { SagaPayload } from '../api.types';
import { CancelVideoUploadRequest, DownloadDocumentRequest, UploadDocumentsRequest } from './document.types';

export const requestDownloadDocument =
  createAction<SagaPayload<DownloadDocumentRequest, ArrayBuffer>['payload']>('request/downloadDocument');

export const requestUploadDocument = createAction<SagaPayload<Document, string>['payload']>('request/uploadDocument');

export const requestUploadDocuments =
  createAction<SagaPayload<UploadDocumentsRequest, FileType[]>['payload']>('request/uploadDocuments');

export const requestCancelVideoUpload =
  createAction<SagaPayload<CancelVideoUploadRequest>['payload']>('request/cancelVideoUpload');
